module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hVJhb9/tc-custom/9783958643307_IMGJPG_FrontCover_0.jpg?1703129215419",
      "alt": "This image is the cover for the book Dantons Tod, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dantons Tod, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Karl Georg Büchner (* 17. Oktober 1813 in Goddelau, Großherzogtum Hessen; † 19. Februar 1837 in Zürich) war ein hessischer Schriftsteller, Mediziner, Naturwissenschaftler und Revolutionär. Er gilt trotz seines schmalen Werkes – er starb bereits im Alter von 23 Jahren – als einer der bedeutendsten Literaten des Vormärz. Teile seines Werkes zählen zur Exilliteratur. (Auszug aus Wikipedia)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Georg Büchner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Karl Georg Büchner (* 17. Oktober 1813 in Goddelau, Großherzogtum Hessen; † 19. Februar 1837 in Zürich) war ein deutscher Schriftsteller, Mediziner, Naturwissenschaftler und Revolutionär. Er gilt trotz seines schmalen Werkes – er starb bereits im Alter von 23 Jahren – als einer der bedeutendsten Literaten des Vormärz. Teile seines Werkes zählen zur Exilliteratur. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB Ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0